import React from "react";
import { Input } from "@pd/pd-ui-kit";
import { Control, Controller, UseFormMethods } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IEmployeeProfileForm } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";
import { useCardEditAccess } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/useCardEditAccess";

import FormDateField from "./FormDateField";
import FormField from "./FormField";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IParametersSectionProps {
  control: Control<IEmployeeProfileForm>;
  errors: UseFormMethods<IEmployeeProfileForm>["errors"];
}

const ParametersSection = ({ control, errors }: IParametersSectionProps) => {
  const { t } = useTranslation();
  const { canEditAll, canEditAny } = useCardEditAccess();

  return (
    <section className={s.section}>
      <h2 className={s.sectionTitle}>{t("employee.listTitleParameter")}</h2>
      <div className={s.parametersRow}>
        <FormField label={t("employee.resourcesControlUserId")}>
          <Controller
            name="resourcesControlUserId"
            control={control}
            render={({ onChange, value, onBlur }) => (
              <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                disabled={!canEditAny}
              />
            )}
          />
        </FormField>
        <FormField label={t("employee.ladaAcademiaId")} required>
          <Controller
            name="ladaAcademiaId"
            control={control}
            render={({ onChange, value, onBlur }) => (
              <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                disabled={!canEditAll}
                status={errors.ladaAcademiaId ? "error" : undefined}
                errorText={errors.ladaAcademiaId?.message}
              />
            )}
          />
        </FormField>
        <FormDateField
          name="createdAt"
          control={control}
          label={t("employee.createdAt")}
          disabled
        />
        <FormDateField
          name="lastEditDate"
          control={control}
          label={t("employee.lastEditDate")}
          disabled
        />
      </div>
    </section>
  );
};

export default ParametersSection;
